import { render, staticRenderFns } from "./CardCreate.vue?vue&type=template&id=12bdfd29"
import script from "./CardCreate.vue?vue&type=script&lang=js"
export * from "./CardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports